import React from 'react';
import { useTranslation } from 'react-i18next';
import Button, { ButtonTypes } from '@lib/components/Button/Button';
import ActionsRow from '@lib/components/ActionsRow/ActionsRow';

interface Props {
  isEditForm?: boolean;
  loading?: boolean;
  onCancel: () => void;
}

function UserFormActions(props: Props) {
  const { isEditForm, loading, onCancel } = props;
  const { t } = useTranslation();
  return (
    <ActionsRow
      actions={[
        <Button
          buttonText={t('cancel')}
          buttonType={ButtonTypes.secondaryOutlined}
          data-test-id="user-form__cancel-button"
          disabled={loading}
          fullWidth
          leftIcon="close"
          onClick={onCancel}
        />,
        <Button
          buttonText={isEditForm ? t('save-changes') : t('create')}
          buttonType={ButtonTypes.primaryFilled}
          data-test-id="user-form__save-button"
          disabled={loading}
          fullWidth
          leftIcon="check"
          type="submit"
        />,
      ]}
    />
  );
}

export default UserFormActions;
